import { useTranslation } from "hhn-commons";
import React, { useEffect, useState } from "react";
import { Dots } from "./MessageStatus.style";

const SendingWithDots = () => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  const [dotCount, setDotCount] = useState(1);
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prev => (prev % 3) + 1);
    }, 500);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {tNs("messageInfo.sending")}
      <Dots>{".".repeat(dotCount)}</Dots>
    </>
  );
};

export default SendingWithDots;
